(() => {
  'use strict';
  if (window.DomotecOrdering) return;
  const source = document.getElementById('domotec-ordering-config');
  if (!source) return;
  const cfg = JSON.parse(source.textContent);
  const policy = cfg.policy;
  if (!policy || !policy.minimum_pieces) return;
  const text = cfg.text;
  const root = window.Shopify?.routes?.root || '/';
  let cart = cfg.cart;
  let rate = null;
  let syncing = false;
  let cartError = false;
  let timer;
  const rendered = new WeakMap();
  const priceValues = new WeakMap();
  function writeHTML(element, value) {
    if (rendered.get(element) === value) return;
    rendered.set(element, value);
    element.innerHTML = value;
  }
  function writeText(element, value) {
    if (rendered.get(element) === value) return;
    rendered.set(element, value);
    element.textContent = value;
  }
  const cartons = new Map(Object.entries(cfg.cartons || {}));
  const money = (cents, currency = cart.currency || cfg.currency) => new Intl.NumberFormat(cfg.locale, {style:'currency', currency}).format(cents / 100);
  const esc = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const minimum = carton => carton >= 100 ? Math.ceil(carton / 2) : carton === 1 ? 1 : carton > 1 && carton < policy.small_carton_below ? policy.small_carton_minimum : policy.minimum_pieces;
  const currency = () => cart.currency || cfg.currency;
  const euCustomer = () => ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PT','RO','SK','SI','ES','SE'].includes(cfg.country);
  const canSeePrices = () => cfg.loggedIn && cfg.verified;
  function euro(cents) {
    return currency() === 'PLN' && rate ? money(Math.round(cents / rate.mid), 'EUR') : '';
  }
  function info(item) {
    const carton = Number(cartons.get(String(item.product_id)) || item.properties?._domotec_carton || 0);
    return {carton, min:minimum(carton)};
  }
  function groups() {
    const result = new Map();
    for (const item of cart.items || []) {
      const id = String(item.product_id);
      const group = result.get(id) || {...info(item), quantity:0, title:item.product_title};
      group.quantity += item.quantity;
      result.set(id, group);
    }
    return result;
  }
  function state() {
    const cur = currency();
    const needsRate = cur === 'PLN' && euCustomer();
    const supported = (cur === 'PLN' || cur === 'EUR') && (!needsRate || !!rate);
    const limit = Math.round(100 * (cur === 'EUR' ? policy.minimum_eur_net : needsRate && rate ? policy.minimum_eur_net * rate.mid : policy.minimum_pln_net));
    const total = Number(cart.total_price || 0);
    const invalid = [...groups().values()].filter(g => g.quantity > 0 && g.quantity < g.min);
    return {limit,total,remaining:Math.max(0,limit-total),invalid,ready:!cartError && supported && total >= limit && !invalid.length && (cart.items || []).length > 0};
  }
  function panelHTML() {
    const s = state();
    const eurTotal = euro(s.total);
    return '<strong>' + esc(text.orderMinimum + ': ' + money(s.limit) + ' ' + text.net) + '</strong>' +
      '<div class="dt-cart-spend">' + esc(text.cartTotal + ': ' + money(s.total) + ' ' + text.net) +
      '<span class="dt-eur">' + (eurTotal ? '≈ ' + esc(eurTotal + ' ' + text.net) : '') + '</span></div>' +
      '<progress max="' + s.limit + '" value="' + Math.min(s.total,s.limit) + '" aria-label="' + esc(text.orderMinimum) + '"></progress>' +
      '<div class="dt-cart-status">' + esc(s.remaining ? text.remaining + ': ' + money(s.remaining) + ' ' + text.net : s.ready ? text.ready : text.fix) + '</div>' +
      (s.invalid.length ? '<div role="alert">' + esc(text.fix + ': ' + s.invalid.map(g => g.title + ' (' + g.quantity + '/' + g.min + ')').join(', ')) + '</div>' : '') +
      '<details class="dt-order-details"><summary>' + esc(text.orderDetails) + '</summary><small>' +
      esc(rate ? text.rate + ': 1 EUR = ' + rate.mid.toFixed(4) + ' PLN · ' + rate.effectiveDate : text.rateUnavailable) +
      '</small><small>' + esc(text.reference) + '</small><small>' + esc(text.vatNotice) + '</small></details>';
  }
  function renderProgress() {
    const visible = canSeePrices();
    const containers = [document.querySelector('#main-cart-footer .cart__blocks')].filter(Boolean);
    for (const container of containers) {
      let panel = container.querySelector('.dt-progress-panel');
      if (!panel) { panel=document.createElement('section');panel.className='dt-progress-panel';panel.setAttribute('aria-live','polite');container.prepend(panel); }
      const html = visible ? panelHTML() : '<a href="' + root + 'account/login">' + esc(text.login) + '</a>';
      panel.dataset.ready = String(state().ready);
      const expanded = panel.querySelector('details')?.open;
      writeHTML(panel, html);
      if (expanded && panel.querySelector('details')) panel.querySelector('details').open = true;
    }
    for (const button of document.querySelectorAll('[name="checkout"], a[href$="/checkout"]')) {
      const blocked = !visible || !state().ready || syncing;
      button.classList.toggle('dt-checkout-blocked',blocked);
      button.setAttribute('aria-disabled',String(blocked));
      if ('disabled' in button) button.disabled=blocked;
    }
  }
  function refreshCart() {
    if (syncing) return;
    syncing=true;
    renderProgress();
    return fetch(root+'cart.js',{cache:'no-store',headers:{Accept:'application/json'}})
      .then(r=>{if(!r.ok)throw new Error(text.error);return r.json();})
      .then(value=>{cart=value;cartError=false;})
      .catch(()=>{cartError=true;})
      .finally(()=>{syncing=false;renderProgress();renderRows();});
  }
  function controls(host, data) {
    if (host.querySelector(':scope > .dt-controls')) return;
    cartons.set(String(data.product),data.carton);
    const min=minimum(data.carton);
    const minCartons=data.carton ? Math.ceil(min/data.carton) : 0;
    const panel=document.createElement('div');
    panel.className='dt-controls';panel.dataset.mode='pieces';
    let adding = false;
    panel.innerHTML='<div class="dt-modes"><button type="button" class="dt-pieces" translate="no" data-mode="pieces" aria-pressed="true">'+esc(text.pieces)+'</button>'+
      (data.carton ? '<button type="button" class="dt-cartons" translate="no" data-mode="cartons" aria-pressed="false">'+esc(text.cartons)+'</button>' : '')+'</div>'+
      '<label><span translate="no" data-dt-label>'+esc(text.quantity)+'</span><input type="number" inputmode="numeric" min="'+min+'" step="1" value="'+min+'" aria-label="'+esc(text.pieces)+'"></label>'+
      '<small>'+esc(text.minimum+': '+min+' '+text.unit+(data.carton ? ' · '+text.perCarton+': '+data.carton : ''))+'</small>'+
      '<strong class="dt-summary"></strong><button type="button" class="dt-add">'+esc(text.add)+'</button><p class="dt-feedback" aria-live="polite"></p>';
    host.append(panel);
    host.classList.add(data.card ? 'dt-has-controls' : 'dt-has-product-controls');
    const input=panel.querySelector('input');
    const feedback=panel.querySelector('.dt-feedback');
    const add=panel.querySelector('.dt-add');
    function current() {
      if (!data.card) {
        const form=host.querySelector('form[action*="/cart/add"]');
        const variant=cfg.product?.variants.find(v=>String(v.id)===String(form?.querySelector('[name="id"]')?.value));
        if(variant){data.variant=variant.id;data.price=variant.price;data.available=variant.available;}
      }
      return panel.dataset.mode==='cartons' ? Number(input.value)*data.carton : Number(input.value);
    }
    function update() {
      const qty=current();
      const allowed=canSeePrices(host);
      const value=qty+' '+text.unit+(allowed ? ' · '+money(qty*data.price)+' '+text.net : '');
      const eurPrice=allowed ? euro(qty*data.price) : '';
      const html=esc(value)+'<span class="dt-eur">'+(eurPrice ? '≈ '+esc(eurPrice+' '+text.net) : '')+'</span>';
      const summary=panel.querySelector('.dt-summary');
      writeHTML(summary,html);
      add.disabled=adding || (cfg.loggedIn && (!cfg.verified || !data.available));
      const label=adding ? text.adding : !cfg.loggedIn ? text.login : !cfg.verified ? text.verification : !data.available ? text.unavailable : text.add;
      writeText(add,label);
      const native=host.querySelector('input[name="quantity"]');
      if(native){native.min=String(min);native.value=String(qty);}
    }
    panel.querySelectorAll('[data-mode]').forEach(button=>button.addEventListener('click',()=>{
      panel.dataset.mode=button.dataset.mode;
      input.min=String(panel.dataset.mode==='cartons'?minCartons:min);
      input.value=input.min;
      input.setAttribute('aria-label',panel.dataset.mode==='cartons'?text.cartons:text.pieces);
      writeText(panel.querySelector('[data-dt-label]'),text.quantity);
      panel.querySelectorAll('[data-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      update();
    }));
    input.addEventListener('change',()=>{input.value=String(Math.max(Number(input.min),Math.floor(Number(input.value)||0)));update();});
    add.addEventListener('click',async()=>{
      if(!cfg.loggedIn){location.href=root+'account/login';return;}
      if(!cfg.verified)return;
      const qty=current();
      if(!Number.isInteger(qty)||qty<min){input.value=input.min;update();return;}
      if(!data.available)return;
      if (adding) return;
      adding=true;writeText(feedback,'');update();
      try {
        const drawer=document.querySelector('cart-drawer');
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:data.variant,quantity:qty,properties:{'_domotec_carton':String(data.carton),'_domotec_policy':'1'}}],sections:['cart-icon-bubble','cart-drawer'],sections_url:location.pathname})});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||text.error);
        if(drawer?.renderContents&&result.sections)drawer.renderContents({...result,id:data.variant});
        else if(result.sections?.['cart-icon-bubble']){
          const parsed=new DOMParser().parseFromString(result.sections['cart-icon-bubble'],'text/html');
          const bubble=document.getElementById('cart-icon-bubble');
          if(bubble)bubble.innerHTML=parsed.querySelector('.shopify-section')?.innerHTML||parsed.body.innerHTML;
        }
        feedback.dataset.error='false';writeText(feedback,text.added);
        await refreshCart();
        document.dispatchEvent(new CustomEvent('domotec:cart-updated'));
      } catch(error){feedback.dataset.error='true';writeText(feedback,error.message);}
      finally{adding=false;update();}
    });
    panel.dtUpdate=update;
    update();
  }
  function renderCards() {
    for (const host of document.querySelectorAll('[data-dt-product]')) {
      if(host.dataset.dtVariants!=='1')continue;
      controls(host,{card:true,product:host.dataset.dtProduct,carton:Number(host.dataset.dtCarton),variant:host.dataset.dtVariant,price:Number(host.dataset.dtPrice),available:host.dataset.dtAvailable==='true'});
    }
    if(cfg.product){
      const host=document.querySelector('.product__info-container');
      if(host)controls(host,{card:false,product:cfg.product.id,carton:Number(cfg.product.carton),variant:null,price:0,available:false});
    }
  }
  function renderRows() {
    const totals=groups();
    for(const row of document.querySelectorAll('.cart-item[data-dt-product]')){
      const carton=Number(row.dataset.dtCarton||0);
      cartons.set(row.dataset.dtProduct,carton);
      const min=minimum(carton);
      const input=row.querySelector('[name="updates[]"], .quantity__input');
      const qty=Number(input?.value||0);
      const invalid=(totals.get(row.dataset.dtProduct)?.quantity||qty)<min;
      const kind=invalid?'invalid':carton&&qty%carton===0?'cartons':'pieces';
      row.dataset.dtKind=kind;
      if(input){input.dataset.dtMinimum=String(min);input.min='0';input.step='1';}
      let badge=row.querySelector('.dt-line-info');
      if(!badge){badge=document.createElement('div');badge.className='dt-line-info';row.querySelector('.cart-item__details')?.append(badge);}
      const line=cart.items?.find(i=>String(i.key)===row.dataset.dtKey);
      const value=line?.final_line_price??Number(row.dataset.dtLinePrice||0);
      const pl = String(cfg.locale).startsWith('pl');
      const remaining = carton > 0 ? (carton - qty % carton) % carton : 0;
      const cartonDetails = carton > 0 ? '<small class="dt-carton-details">' + esc(pl ? 'Sztuk w kartonie: ' + carton : 'Pieces per carton: ' + carton) + '</small>' : '';
      const complete = carton > 0 && !remaining ? '<small class="dt-carton-details">' + esc(pl ? 'Pełne kartony · ' + qty + ' szt.' : 'Full cartons · ' + qty + ' pieces') + '</small>' : '';
      const topUp = remaining > 0 ? '<button type="button" class="dt-carton-topup" data-dt-topup="' + (qty + remaining) + '">' + esc(pl ? 'Dodaj ' + remaining + ' szt., aby uzupełnić karton' : 'Add ' + remaining + ' pieces to complete a carton') + '</button>' : '';
      const html='<span class="dt-badge" data-kind="'+kind+'">'+esc(kind==='invalid'?text.minimum+': '+min+' '+text.unit:kind==='cartons'?text.cartons+': '+qty/carton:text.pieces+': '+qty)+'</span>'+
        (canSeePrices()?'<span class="dt-eur">'+(euro(value)?'≈ '+esc(euro(value)+' '+text.net):'')+'</span>':'');
      writeHTML(badge,html + cartonDetails + complete + (canSeePrices() ? topUp : ''));
    }
  }
  function renderEuro() {
    if(currency()!=='PLN'||!canSeePrices())return;
    for(const element of document.querySelectorAll('.price-item--regular, .price-item--sale, .totals__total-value')){
      let cents = priceValues.get(element);
      if(element.classList.contains('totals__total-value')) cents=Number(cart.total_price || 0);
      if(cents === undefined) {
        const parts = new Intl.NumberFormat(cfg.locale).formatToParts(12345.6);
        const group = parts.find(p=>p.type==='group')?.value || '';
        const decimal = parts.find(p=>p.type==='decimal')?.value || '.';
        const raw = [...element.childNodes].filter(n=>!n.classList?.contains('dt-eur')).map(n=>n.textContent).join('').split(group).join('').replace(decimal,'.').replace(/[^\d.]/g,'');
        cents=Math.round(Number(raw)*100);
        if(!Number.isFinite(cents))continue;
        priceValues.set(element,cents);
      }
      let secondary=element.querySelector('.dt-eur');
      if(!secondary){secondary=document.createElement('small');secondary.className='dt-eur';element.append(secondary);}
      writeText(secondary,rate && cents ? '≈ '+euro(cents)+' '+text.net : '');
    }
  }
  function renderPriceBadges() {
    for (const host of document.querySelectorAll('.product-card-wrapper[data-dt-product]')) {
      const image = host.querySelector('.card__inner');
      if (!image) continue;
      let badge = image.querySelector('.dt-piece-price-tag');
      if (!canSeePrices()) {
        badge?.remove();
        image.classList.remove('dt-price-tag-space');
        continue;
      }
      const cents = Number(host.dataset.dtPrice);
      if (!Number.isFinite(cents) || cents < 0) continue;
      if (!badge) {
        badge = document.createElement('div');
        badge.className = 'dt-piece-price-tag';
        badge.setAttribute('translate', 'no');
        image.append(badge);
      }
      image.classList.add('dt-price-tag-space');
      const suffix = ' / ' + text.unit + ' ' + text.net;
      const secondary = euro(cents);
      writeHTML(badge, '<strong>' + esc(money(cents) + suffix) + '</strong><small>' + (secondary ? '≈ ' + esc(secondary + suffix) : '') + '</small>');
      if (rate) badge.title = text.rate + ': 1 EUR = ' + rate.mid.toFixed(4) + ' PLN · ' + rate.effectiveDate;
    }
  }
  function render() {
    renderCards();renderRows();renderProgress();renderEuro();renderPriceBadges();
    document.querySelectorAll('.dt-controls').forEach(panel=>panel.dtUpdate?.());
  }
  async function loadRate() {
    try {
      const response=await fetch('https://api.nbp.pl/api/exchangerates/rates/a/eur/?format=json',{cache:'no-store',signal:AbortSignal.timeout(8000)});
      if(!response.ok)throw new Error();
      const data=await response.json();
      const value=data.rates?.[0];
      if(!value||!Number.isFinite(value.mid)||value.mid<=0||!/^\d{4}-\d{2}-\d{2}$/.test(value.effectiveDate))throw new Error();
      rate=value;sessionStorage.setItem('domotec-nbp-eur',JSON.stringify(value));
    } catch {
      try {const cached=JSON.parse(sessionStorage.getItem('domotec-nbp-eur'));if(cached?.mid>0&&cached.effectiveDate)rate=cached;}catch{}
    }
    render();
  }
  function start() {
    document.documentElement.classList.add('dt-ordering-ready');
    document.documentElement.classList.toggle('dt-prices-locked',!canSeePrices());
    render();loadRate();
    const relevant = '.product-card-wrapper[data-dt-product],.product__info-container,.cart-item,#main-cart-footer,#CartDrawer,.price-item--regular,.price-item--sale,.totals__total-value';
    new MutationObserver(records=>{
      const replaced = records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1 && (node.matches(relevant)||node.querySelector(relevant))));
      if(!replaced)return;
      clearTimeout(timer);timer=setTimeout(render,80);
    }).observe(document.body,{childList:true,subtree:true});
    const nativeFetch=window.fetch;
    window.fetch=function(...args){
      const response=nativeFetch.apply(this,args);
      const url=String(args[0]?.url||args[0]);
      if(/\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url))response.then(()=>setTimeout(refreshCart,150)).catch(()=>{});
      return response;
    };
    document.addEventListener('change',event=>{
      if(event.target.matches('.cart-item .quantity__input')){
        const input=event.target;
        const qty=Number(input.value);
        const min=Number(input.dataset.dtMinimum||policy.minimum_pieces);
        const productId=input.closest('.cart-item')?.dataset.dtProduct;
        const previous=cart.items.find(i=>i.key===input.closest('.cart-item')?.dataset.dtKey)?.quantity||qty;
        const other=(groups().get(productId)?.quantity||previous)-previous;
        if(qty>0&&qty+other<min)input.value=String(min-other);
      }
    },true);
    document.addEventListener('click',event=>{
      const topUp = event.target.closest('[data-dt-topup]');
      if (topUp) {
        event.preventDefault();
        const row = topUp.closest('.cart-item');
        const input = row?.querySelector('[name="updates[]"], .quantity__input');
        if (input && !syncing) {
          input.value = topUp.dataset.dtTopup;
          input.dispatchEvent(new Event('change', {bubbles:true}));
        }
        return;
      }
      const checkout=event.target.closest('[name="checkout"],a[href$="/checkout"]');
      if(checkout&&(!state().ready||!canSeePrices()||syncing)){event.preventDefault();event.stopImmediatePropagation();document.querySelector('.dt-progress-panel')?.scrollIntoView({block:'center'});}
    },true);
    document.addEventListener('submit',event=>{
      if(event.submitter?.name==='checkout'&&(!state().ready||!canSeePrices()||syncing)){event.preventDefault();event.stopImmediatePropagation();}
      const form=event.target;
      if(form.matches('form[action*="/cart/add"]')){
        const host=form.closest('[data-dt-product]')||document.querySelector('.product__info-container');
        const carton=Number(host?.dataset.dtCarton||cfg.product?.carton||0);
        let input=form.querySelector('[name="quantity"]');
        if(!input){input=document.createElement('input');input.type='hidden';input.name='quantity';form.append(input);}
        input.value=String(Math.max(minimum(carton),Number(input.value)||0));
      }
    },true);
    setInterval(loadRate,30*60*1000);
  }
  window.DomotecOrdering={minimum,state,groups,refreshCart,policy};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();


